import { useState } from "react";
import { deltamathAPI } from "../utils";
import axios from "axios";
import { useDeltaToastContext } from "../../shared/contexts/ToasterContext";
import { useMutation } from "@tanstack/react-query";

const CopyStudentData = () => {
  const [sourceId, setSourceId] = useState("");
  const [destinationId, setDestinationId] = useState("");
  const toastContext = useDeltaToastContext();

  const mutation = useMutation({
    mutationFn: async () => {
      return axios.put(
        `${deltamathAPI()}/manager_new/manage/copyStudentData`,
        null,
        {
          params: {
            sourceId,
            destinationId,
          },
        }
      );
    },
    onSuccess: () => {
      toastContext.addToast({
        status: "Success",
        message: "Student data copied successfully",
      });
      // Clear form
      setSourceId("");
      setDestinationId("");
    },
    onError: () => {
      toastContext.addToast({
        status: "Error",
        message: "Failed to copy student data. Please try again.",
      });
    },
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate();
  };

  return (
    <div className="p-6">
      <h1 className="mb-6 text-2xl font-bold">Copy Student Data</h1>
      <form onSubmit={handleSubmit} className="max-w-md space-y-4">
        <div>
          <label
            htmlFor="sourceId"
            className="block text-sm font-medium text-gray-700"
          >
            Source Student ID *
          </label>
          <input
            type="text"
            id="sourceId"
            required
            value={sourceId}
            onChange={(e) => setSourceId(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div>
          <label
            htmlFor="destinationId"
            className="block text-sm font-medium text-gray-700"
          >
            Destination Student ID *
          </label>
          <input
            type="text"
            id="destinationId"
            required
            value={destinationId}
            onChange={(e) => setDestinationId(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <button
          type="submit"
          disabled={mutation.isPending}
          className="flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50"
        >
          {mutation.isPending ? "Copying..." : "Copy Student Data"}
        </button>
      </form>
    </div>
  );
};

export default CopyStudentData;
